import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetContractDetails, GetContractDetailsVariables }
  from '@/graphql/contracts/_generated_/getContractDetails.query';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetContractDetailsFromCache(contractId: UUID): Contract | null {
  try {
    const contract = apolloClientContracts.cache.readQuery<GetContractDetails, GetContractDetailsVariables>({
      query: GetContractDetailsQuery,
      variables: { contractId },
    });

    return contract?.contract || null;
  } catch(err: any) {
    notificationService.open({
      title: 'Error',
      text: err?.message || 'Something went wrong during loading contract',
      type: 'danger'
    });

    return null;
  }
}
